import React from 'react';
import PropTypes from 'prop-types';
import { Card, Typography, Tag } from 'antd';
import { LockOutlined, GlobalOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { brandingConfig } from '../../../../config';

const { Title } = Typography;

// No orgSlug (org has no slug yet) means no valid per-experience link --
// fall back to plain /map instead of the removed flat /map/:slug route.
const buildExperienceLink = (orgSlug, experience) => {
  if (!orgSlug) return '/map';
  return experience?.is_default ? `/map/${orgSlug}` : `/map/${orgSlug}/${experience?.slug}`;
};

const ExperienceCard = ({ experience, orgSlug }) => (
  <Link to={buildExperienceLink(orgSlug, experience)} style={{ height: '100%' }}>
    <Card
      bordered={false}
      key={experience?.experience_id}
      style={{
        borderRadius: 8,
        color: '#fff',
        background: brandingConfig.colors.header,
        height: '100%',
      }}
    >
      {experience?.logo_url && (
        <img src={experience.logo_url} alt="" style={{ maxHeight: 24, maxWidth: 120, marginBottom: 10 }} />
      )}
      <Title level={5} style={{ color: '#fff' }}>
        {experience?.name}
      </Title>
      {experience?.description && (
        <div style={{ marginBottom: 10 }}>
          {experience.description}
        </div>
      )}
      {experience?.visibility === 'group_members_only' ? (
        <Tag icon={<LockOutlined />}>
          Members Only
        </Tag>
      ) : (
        <Tag icon={<GlobalOutlined />} color="green">
          Public
        </Tag>
      )}
    </Card>
  </Link>
);

ExperienceCard.propTypes = {
  experience: PropTypes.object,
  orgSlug: PropTypes.string,
};

ExperienceCard.defaultProps = {
  experience: {},
  orgSlug: null,
};

export default ExperienceCard;
